const isLocalHost = window.location.hostname.includes("localhost");
const isEmptyEnv = !process.env.REACT_APP_BASE_URL_API?.trim();

const url =
  isEmptyEnv && isLocalHost
    ? "https://api.octopusic.com.br"
    : `https://api.${window.location.host.split(".").slice(1).join(".")}`;

const urlUploads =
  isEmptyEnv && isLocalHost
    ? "http://localhost:2000"
    : `https://uploads.${window.location.host.split(".").slice(1).join(".")}`;

const api = process.env.REACT_APP_BASE_URL_API?.trim() || url;

const apiUploads =
  process.env.REACT_APP_BASE_URL_API_UPLOADS?.trim() || urlUploads;

const config = {
  isDev: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
  urlApi: api,
  urlUploads: apiUploads,
  firebase: {
    apiKey: "AIzaSyD7fCy7J85gj8QJQPaGZffS5hQwymBmTsQ",
    projectId: "octopus-app-d3d22",
    authDomain: "octopus-app-d3d22.firebaseapp.com",
    storageBucket: "octopus-app-d3d22.appspot.com",
    messagingSenderId: "961312071873",
  },
  mixpanel: {
    key: "510da3742779e88567c864a9d868b57f",
  },
  zendeskKey: process.env.ZENDESK_KEY || "59ef4008-7589-429c-8240-37905e5a6643",
  zendekToken:
    "e3ygrk9-8p1KC3vlrIm3jpviZRsFwt_gkGhjdsESOVbjpN3LWpRcm6Ao_-dL5fTJcDyzYUadZYhd_-vMDXRZmg",
  hotjar: 2932295,
  clarity: {
    key: "vd6jegiglk",
  },
};

// https://api.octopusci.dev.br/docs

export default config;
